import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { EstructuraPlan } from '../../services/negocio.service';

export interface MargenBrutoPdfFila {
  pregunta: string;
  respuestaModo: 'texto' | 'bullets';
  respuestaTexto?: string;
  respuestaItems?: string[];
}

export interface MargenBrutoPdfSubGrupo {
  clave: string;
  tituloVisible: string;
  filas: MargenBrutoPdfFila[];
}

export interface MargenBrutoPdfGrupo {
  clave: string;
  tituloVisible: string;
  filas: MargenBrutoPdfFila[];
  subgrupos?: MargenBrutoPdfSubGrupo[];
}

export interface MargenBrutoPdfMeta {
  productor?: string | null;
  rut?: string | null;
  unidad_operativa?: string | null;
  rubro_principal?: string | null;
  elaborado_por?: string | null;
  aprobado_por?: string | null;
  fecha_aprobacion?: string | null;
  estado?: string | null;
  version?: string | null;
}

@Component({
  selector: 'app-margen-bruto-pdf',
  templateUrl: './margen-bruto-pdf.component.html',
  styleUrls: ['./margen-bruto-pdf.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MargenBrutoPdfComponent {
  @Input() estructura: EstructuraPlan | null = null;
  @Input() meta: MargenBrutoPdfMeta | null = null;
  @Input() grupos: MargenBrutoPdfGrupo[] = [];
  @Input() logoSrc: string = 'assets/logo-indap.png';

  get ahora(): string {
    const d = new Date();
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = String(d.getFullYear());
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${dd}-${mm}-${yyyy} a las ${hh}:${min}hrs`;
  }

  get versionPdf(): string | null {
    const v = (this.meta?.version ?? '').trim();
    return v || null;
  }

  formatearFechaIso(fechaIso: string | null | undefined): string {
    const t = (fechaIso ?? '').trim();
    if (!t) return '';
    const datePart = t.split('T')[0] ?? t;
    const parts = datePart.split('-');
    if (parts.length !== 3) return datePart;
    const [y, m, d] = parts;
    if (!y || !m || !d) return datePart;
    return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
  }

  trackByGrupo(index: number, grupo: MargenBrutoPdfGrupo): string {
    return grupo.clave || String(index);
  }

  
  trackBySubGrupo(index: number, grupo: MargenBrutoPdfSubGrupo): string {
    return grupo.clave || String(index);
  }

  trackByFila(index: number, fila: MargenBrutoPdfFila): string {
    return `${index}-${fila.pregunta}`;
  }
}
